import { get, post, req } from '@/plugins/axios'

// 商品tiktok分类列表
export function ttsCategories (data?: any) {
  return get('/api/tts/categories', data)
}

// 商品tiktok 地址设置
export function ttsCreatProductCheck (data?: any) {
  return req('/api/tts/creatProductCheck', data)
}

// 设置库存
export function ttsSetSkuStock (data?: any) {
  return req('/api/tts/setSkuStock', data)
}

// 设置库存
export function ttsPploadImage (data?: any) {
  return post('/api/tts/uploadImage', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 是否tk白名单
export function isTkWhiteUserApi (data?: any) {
  return req('/api/thirdShopOrder/isT2SShop', data)
}

// 一键绑定api
export function bindByshopItemIdApi (data?: any) {
  return post('/api/thirdShopItem/bindByshopItemId', data)
}

// 下载失败文件
export function downloadFailFileApi (data?: any) {
  return post('/api/thirdShopItem/downloadAutoBindFailed', data)
}
